/**
 * Custom Finance routes
 *
 * Extends the auto-generated finance routes with bespoke pages that are not part of the DSL
 * (the plan-entry grid). Custom routes come first so they take precedence over generated ones.
 */

import { financeRoutes as generatedFinanceRoutes } from './finance.generated';
import { PlanEntryGrid } from '@/finance/PlanEntryGrid';
import { PlanRollupView } from '@/finance/PlanRollupView';
import { BudgetSetupView } from '@/finance/BudgetSetupView';

const customFinanceRoutes = [
  {
    path: '/finance/setup/budget',
    element: <BudgetSetupView />,
  },
  {
    path: '/finance/plan-entry',
    element: <PlanEntryGrid />,
  },
  {
    path: '/finance/plan-entry/:headerId',
    element: <PlanEntryGrid />,
  },
  {
    path: '/finance/plan-rollup',
    element: <PlanRollupView />,
  },
  {
    path: '/finance/plan-rollup/:planVersionId/:orgUnitId',
    element: <PlanRollupView />,
  },
];

export const financeRoutes = [
  ...customFinanceRoutes,
  ...generatedFinanceRoutes,
];
